module.exports = __webpack_public_path__ + "img/0Q3B1891_L_WoodMatted_MockedUp.be952096.jpg";